(function () {
  var api = window.NCBannerCarousel || {};
  var heightClasses = [
    "nc-banner-carousel--small",
    "nc-banner-carousel--medium",
    "nc-banner-carousel--large"
  ];

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function clearTimer(state) {
    if (state && state.timer) {
      window.clearInterval(state.timer);
      state.timer = null;
    }
  }

  function setRootHeightClass(root, heightVariant) {
    heightClasses.forEach(function (className) {
      root.classList.remove(className);
    });

    root.classList.add("nc-banner-carousel--" + (heightVariant || "large"));
  }

  function setActiveSlide(root, index) {
    var state = root.ncBannerCarouselState;
    if (!state || !state.slides.length) return;

    var nextIndex = (index + state.slides.length) % state.slides.length;
    state.activeIndex = nextIndex;

    state.slides.forEach(function (slide, slideIndex) {
      var isActive = slideIndex === nextIndex;
      slide.classList.toggle("is-active", isActive);
      slide.setAttribute("aria-hidden", isActive ? "false" : "true");

      if (isActive) {
        setRootHeightClass(root, slide.getAttribute("data-nc-banner-height") || "large");
      }
    });

    state.dots.forEach(function (dot, dotIndex) {
      var isActive = dotIndex === nextIndex;
      dot.classList.toggle("nc-banner-carousel__dot--active", isActive);

      if (isActive) {
        dot.setAttribute("aria-current", "true");
      } else {
        dot.removeAttribute("aria-current");
      }
    });
  }

  function startTimer(root) {
    var state = root.ncBannerCarouselState;
    if (!state || state.slides.length <= 1 || prefersReducedMotion()) return;

    clearTimer(state);
    state.timer = window.setInterval(function () {
      setActiveSlide(root, state.activeIndex + 1);
    }, 5200);
  }

  function resetRoot(root) {
    var state = root && root.ncBannerCarouselState;
    if (!state) return;

    clearTimer(state);

    state.dots.forEach(function (dot) {
      dot.removeEventListener("click", state.handlers.dotClick);
    });

    delete root.ncBannerCarouselState;
    delete root.dataset.ncBannerCarouselInitialized;
  }

  function initRoot(root) {
    if (!root || root.dataset.ncBannerCarouselInitialized === "true") return;

    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-nc-banner-slide]"));
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-nc-banner-dot]"));

    if (!slides.length) return;

    var state = {
      slides: slides,
      dots: dots,
      activeIndex: 0,
      timer: null,
      handlers: {}
    };

    state.handlers.dotClick = function (event) {
      var dot = event.currentTarget;
      var index = parseInt(dot.getAttribute("data-nc-banner-index") || "0", 10);
      setActiveSlide(root, index);
      startTimer(root);
    };

    dots.forEach(function (dot) {
      dot.addEventListener("click", state.handlers.dotClick);
    });

    root.ncBannerCarouselState = state;
    root.dataset.ncBannerCarouselInitialized = "true";

    setActiveSlide(root, 0);
    startTimer(root);
  }

  function initAll(scope) {
    var rootScope = scope || document;
    var roots = rootScope.querySelectorAll
      ? rootScope.querySelectorAll("[data-nc-banner-carousel]")
      : [];

    Array.prototype.forEach.call(roots, initRoot);
  }

  api.init = initAll;
  api.destroy = function (scope) {
    var rootScope = scope || document;
    var roots = rootScope.querySelectorAll
      ? rootScope.querySelectorAll("[data-nc-banner-carousel]")
      : [];

    Array.prototype.forEach.call(roots, resetRoot);
  };

  window.NCBannerCarousel = api;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    api.destroy(event.target);
  });
})();
